import { render, staticRenderFns } from "./IntroContact.vue?vue&type=template&id=15b78800"
import script from "./IntroContact.vue?vue&type=script&lang=js"
export * from "./IntroContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports